import { Attachment } from '../_blessed/components/features/Dispatch/store/attachments/model';

export default function generateAttachmentDisplayName(attachmentAttributes: Attachment) {
  if (attachmentAttributes.type === 'pierpass_not_paid') return 'PierPass';
  if (attachmentAttributes.type === 'pierpass_paid') return 'PierPass';
  if (attachmentAttributes.type === 'pierpass') return 'PierPass';
  if (attachmentAttributes.type) return attachmentAttributes.type;
  return 'No attachment type';
}
